/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import Link from 'components/common/link';

import { aboutUsItems, guidesItems, howItWorksItems } from './utils';
import { useAuth } from 'lib/auth';
import { routePaths } from 'appConfig';
import {
  isClickAndCollectEnabled,
  isResumedClickAndCollectNoticeEnabled,
} from 'lib/click-and-collect';
import { Badge } from 'react-bootstrap';

function MobileMainNav(props) {
  const { cateringEnabled, ybExpressEnabled } = props;
  const { session, signOut } = useAuth();

  return (
    <nav className="mobile-nav">
      <ul className="mobile-menu">
        <li>
          <Link to={'/'}>
            <>Home</>
          </Link>
        </li>

        <li>
          <Link to={routePaths.CATEGORIES}>
            <>Order Now</>
          </Link>
        </li>

        <li>
          <a
            className="text-white"
            style={{ textDecoration: 'none' }}
          >
            About Us
          </a>

          <ul>
            {aboutUsItems
              .filter((item) => {
                if (
                  !cateringEnabled &&
                  item.to === routePaths.CATERING
                )
                  return false;
                if (
                  !ybExpressEnabled &&
                  item.to === routePaths.YB_EXPRESS
                )
                  return false;
                return true;
              })
              .map((item) => (
                <li>
                  <Link to={item.to} activeClassName="active">
                    <>{item.label}</>
                  </Link>
                </li>
              ))}
          </ul>
        </li>

        <li>
          <a
            className="text-white"
            style={{ textDecoration: 'none' }}
          >
            How It Works
          </a>

          <ul>
            {howItWorksItems.map((item) => (
              <li>
                <Link to={item.to} activeClassName="active">
                  <div className="tw-flex tw-items-center tw-justify-between">
                    {item.label}
                    {item.to === routePaths.CLICK_AND_COLLECT && (
                      <>
                        {!isClickAndCollectEnabled() ? (
                          <Badge className="tw-uppercase tw-bg-primary tw-text-white tw-tracking-widest tw-px-3 tw-m-0 tw-leading-none">
                            Paused
                          </Badge>
                        ) : (
                          isResumedClickAndCollectNoticeEnabled() && (
                            <Badge className="tw-uppercase tw-bg-primary tw-text-white tw-tracking-widest tw-px-2 tw-m-0 tw-leading-none">
                              Resumed
                            </Badge>
                          )
                        )}
                      </>
                    )}
                  </div>
                </Link>
              </li>
            ))}
          </ul>
        </li>

        <li>
          <a
            className="text-white"
            style={{ textDecoration: 'none' }}
          >
            Guides & FAQs
          </a>

          <ul>
            {guidesItems.map((item) => (
              <li>
                <Link to={item.to} activeClassName="active">
                  <>{item.label}</>
                </Link>
              </li>
            ))}
          </ul>
        </li>

        <li>
          <Link to={routePaths.CART}>
            <>Cart</>
          </Link>
        </li>

        {session ? (
          <>
            <li>
              <Link to={routePaths.ACCOUNT}>
                <>My Account</>
              </Link>
            </li>
            <li>
              <Link
                to={routePaths.YB_PERKS}
                className="tw-flex tw-items-center tw-gap-3"
              >
                <>YB Perks</>
              </Link>
            </li>
            <li>
              <a
                className="text-white"
                onClick={() =>
                  signOut({ redirect: true, callbackUrl: undefined })
                }
              >
                Sign Out
              </a>
            </li>
          </>
        ) : (
          <>
            <li>
              <Link
                to={routePaths.YB_PERKS}
                className="tw-flex tw-items-center tw-gap-3"
              >
                <>YB Perks</>
              </Link>
            </li>
            <li>
              <Link to={routePaths.LOGIN}>
                <>Sign In / Register</>
              </Link>
            </li>
          </>
        )}
      </ul>
    </nav>
  );
}

export default MobileMainNav;
